<template>
  <div id="MyTitle">
    <div @click="() => !noBack && $router.back()" class="left">
      <img v-if="!noBack" src="@icon/back.png" alt="" class="iconBack" />
    </div>
    <div class="title">{{ title || $route.meta.title }}</div>
    <div @click="() => tapRight && tapRight()" class="right">
      <span>{{ right }}</span>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  name: "MyTitle",
  props: {
    noBack: Boolean,
    title: String,
    right: String,
    tapRight: Function,
  }
}
</script>

<style scoped>
#MyTitle {
  display: flex;
  /* padding: 0 var(--dimApp); */
  height: var(--dimHeader);
  align-items: center;
}

.left {
  flex: 1;
  display: flex;
  align-items: center;
}

.iconBack {
  height: var(--dimApp);
  object-fit: contain;
}

.title {
  flex: 2;
  text-align: center;
}

.right {
  flex: 1;
  text-align: right;
  color: var(--colorApp);
}
</style>